import { type SelectionMachine } from '../../machine/selection-machine';

import { type ClickTarget } from './get-click-target';

export function dispatchInitialClick(
  machine: SelectionMachine,
  target: ClickTarget,
  shift = false
): void {
  if (target.type === 'cell') {
    if (shift) {
      const state = machine.getState();
      // Only extend if we're in cell mode and have a selection
      if (state.mode === 'cell' && state.selections.length === 1) {
        machine.dispatch({
          type: 'extendToCell',
          cell: target.position,
          source: 'mouse',
        });
        return;
      }
    }
    // Treat as regular click when not in cell mode/no selection
    machine.dispatch({ type: 'selectCell', cell: target.position, source: 'mouse' });
    return;
  }

  if (target.type === 'row') {
    if (shift) {
      const state = machine.getState();
      // Only extend if we're in row mode and have a selection
      if (state.mode === 'row' && state.selections.length === 1) {
        machine.dispatch({
          type: 'extendToRow',
          row: target.row,
          source: 'mouse',
        });
        return;
      }
    }
    // Treat as regular click when not in row mode/no selection
    machine.dispatch({ type: 'toggleRow', row: target.row, source: 'mouse' });
    return;
  }

  // TODO: Handle columnHeader
}
